import ReactGA from 'react-ga4';

const GAMeasurementId = 'G-GFN45DEMBX';

export const initializeGoogleAnalytics = () => {
  ReactGA.initialize(GAMeasurementId);
};
